$(document).ready(function(){
    /*
    $(document).on('click','.pdp-qty-plus', function() {
        let inputQty = ($(this).prev().val() * 1);
        let maxQty = ($(this).prev().attr('max-qty') * 1);
        if (inputQty == maxQty) return true;
       inputQty ++;
        $(this).prev().val(inputQty);
        $('.exact-qty').val(inputQty);
    });
    $(document).on('click','.pdp-qty-minus', function() {
        let minQty = 
        let inputQty = ($(this).next().val() * 1);
        if (inputQty == '1') return true;
       inputQty --;
        $(this).next().val(inputQty);
        $('.exact-qty').val(inputQty);
    });
    */
$('.add-btn').on('click', function(e) {
    e.preventDefault();
    var form = $('#go_checkout');
    var prevPincode = getCookie('pincode');
    var deliver = getCookie('deliver');
    
    // if (deliver != 1) {
    //     if (prevPincode > 0) {
    //         $('#pincodePopupMessage').html("<div class='error'>Sorry, We don’t deliver to your location.</div>");
    //     }
    //     $('.userPincode').val(prevPincode);
    //     $('#location-modal').addClass('showPincodePopup');
    //     return false;
    // }

    var isLoyalty = 1; 
    var tagsValue = (isLoyalty == 1) ? 'Loyalty' : 'Earn';
     var rclubId = $('#customer-rclub-id').val();
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes: {
                'rclub_id': rclubId,
                'Tags': tagsValue
            }
        })
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to update cart. Status: ' + response.status);
        }
        return response.json();
    })
    .then((response) => {
        console.log('Cart attribute updated:', response);

        return fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to clear cart. Status: ' + response.status);
        }
        return response.json();
    })
    .then((response) => {
        console.log('Cart cleared:', response);

        // Add the selected product to the cart
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: form.find('input[name="id"]').val(),
                quantity: form.find('input[name="quantity"]').val()
            })
        });
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart. Status: ' + response.status);
        }
        return response.json();
    })
    .then((response) => {
        console.log('Product added to cart:', response);
        window.location = '/checkout'; 
    })
    .catch((error) => {
        console.error('Error during checkout process:', error);
    });
});
  
  $('.qty-plus-sub,.qty-minus-sub').css("cursor","pointer");
  jQuery(document).on('click','.qty-plus-sub',function(e) {
        e.preventDefault(); 
        var item = jQuery(this).attr('data-item').replace(':','\\:');
        var value = jQuery('.item_' + item + ' .qty').val();
        var max = jQuery('.item_' + item + ' .qty').attr('max');
        
        value = (value * 1 ) + 1;
        if(max < 1){
          alert('Product not Available');
          return false;
        }
        if(value > max ){
          value = max;
          alert('Maximum '+max+' Quanity Allowed.');
          return false;
        }
        jQuery('.item_' + item + ' .qty').val(value);       
        cartChange(item);

    });
    jQuery(document).on('click','.qty-minus-sub',function(e){
        e.preventDefault();          
        var item = jQuery(this).attr('data-item').replace(':','\\:');        
        var value = jQuery('.item_' + item + ' .qty').val();
        var old_value = value;
        var min = jQuery('.item_' + item + ' .qty').attr('min');
        if(value <= min ){
          value = min;
          return false;
        }
        value = (value*1)-1;
        jQuery('.item_' + item + ' .qty').val(value);       
        cartChange(item);      
    })
    function cartChange(item) {
        let pid = jQuery('[name="id"]', item).val();
        var Item = '.item_' + item;
        var $btn = jQuery('.qty-minus-sub, .qty-plus-sub',Item);
        var $items = jQuery('.slideCart-item');
        var qty = jQuery('[name="quantity"]',Item).val();
        $btn.attr('disabled',1);
        $(".cart-page-listing").css("opacity", ".3");
        var formData = { updates: {} };
        formData.updates[item] = qty;
        jQuery.ajax({
          url: "/cart/update",
          type: "POST",
          data:formData,
          success: function(cart) {
            console.log(cart);
            $btn.removeAttr('disabled',1)
            $cart = jQuery(cart);            
            location.reload();          
            let count = jQuery('#cart-count',$cart).text();
            jQuery('#cart-count').html(count);  
            $("body").css({ opacity: 1.0 });
          },
          error:function(err,status){
            // console.log(err);
            // console.log(status);
            //alert('You can\'t add more Quantity.');
             $btn.removeAttr('disabled',1)
             $(".cart-page-listing").css("opacity", ".3");
            jQuery('[name="quantity"]',Item).val(qty-1);
            jQuery(".err-msg").html("You can\'t add more Quantity.").css({color: "red",fontWeight:600});
            
          }
        });       
    }
    
   function instantBuy(){
     var $ = jQuery;
   var formParams = $('form.cart').serialize();
     $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){ 
       window.location.href = "/checkout";
      },
      error: function(){
      }
     })
 }
    $('.tooglebar').click(function(){
        $('.bg-layer').addClass("active");
        $('.close-menu').addClass("active");
        $('.nav-box').addClass("active");
    });

    $('.bg-layer').click(function(){
        $(this).removeClass("active");
        $('.close-menu').removeClass("active");
        $('.nav-box').removeClass("active");
      $("body").removeClass("overflow-scroll-y")
    });
    $('.footer-title').click(function () {
        $(this).parent(".footer-colm").toggleClass('active').siblings(".footer-colm").removeClass("active");
    });
    $('.wishlist-icon').on('click', function(){
        $(this).toggleClass('active');
      });

      $('.option-title').click(function () {
        $(this).parent(".pdp-accordian-box").toggleClass('active').siblings(".pdp-accordian-box").removeClass("active");
    });
      $('.tab-menu-list li span').on('click', function(){
        var target = $(this).attr('data-rel');
        $('.tab-menu-list li span').removeClass('active');
          $(this).addClass('active');
          $("#"+target).fadeIn('slow').siblings(".tab-output-box").hide();
          try{
          var tabName = $(this).attr('data-rel');
          $(".membership_popup .membershipContent").removeClass("guestColor welcomeColor blueColor silverColor goldColor platinumColor");
          $(".membership_popup .membershipContent").addClass(tabName + "Color" )
          console.log(tabName);
        }catch(error){
          
        }
                   return false;
    });

      $('.color_loyality').on('click', function(){
       
        var tabName = $(this).attr('data-rel');
          $(".membership_popup .membershipContent").removeClass("guestColor welcomeColor blueColor silverColor goldColor platinumColor");
          $(".membership_popup .membershipContent").addClass(tabName + "Color" )
    });
  
    $('.tabscatgory li span').click(function () {
        var position = $(this).position();
        scroll = $('.tabscatgory').scrollLeft();
        $('.tabscatgory').animate({
            'scrollLeft': scroll + position.left - 30
        }, 200);
    });

 // popup modal js for loyalty
  $(".open_modal").click(function(){
    $(".membership_popup").show();
    $("body").addClass("overflow-h");
    var tabName = $(this).attr('data-tab');
    $(".tab-menu-list li span").removeClass("active");
      $(".tab-output-box").hide();
        // $(".membership_popup .membershipContent").removeClass("welcomeColor blue");
    
    switch (tabName){
      case "guest":
    $("#guest").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("guestColor");
         $(".tab-menu-list li #guesttab").addClass("active");
        break;

      case "welcome":
    $("#welcome").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("welcomeColor");
         $(".tab-menu-list li #welcometab").addClass("active");
        break;
        

          case "blue":
    $("#blue").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("blueColor");
        
         $(".tab-menu-list li #bluetab").addClass("active");
        
        break;
          case "silver":
    $("#silver").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("silverColor");
        
         $(".tab-menu-list li #silvertab").addClass("active");
        
        break;
          case "gold":
    $("#gold").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("goldColor");
        
         $(".tab-menu-list li #goldtab").addClass("active");
        
        break;
          case "platinum":
    $("#platinum").fadeIn('slow')
        $(".membership_popup .membershipContent").addClass("platinumColor");
        
         $(".tab-menu-list li #platinumtab").addClass("active");
        
        break;
    }
    
  })
  $(".close-layer").click(function(){
    $(".membership_popup").hide();
    $("body").removeClass("overflow-h");
    
    
  })
   $(".close").click(function(){
    $(".membership_popup").hide();
    $("body").removeClass("overflow-h");
     
    
  })




  
    $('.tab-menu-list-pdp li span').on('click', function(){
        var target3 = $(this).attr('data-rel');
        $('.tab-menu-list-pdp li span').removeClass('active');
          $(this).addClass('active');
          $("#"+target3).fadeIn('slow').siblings(".tab-output-box-pdp").hide();
          return false;
    });
    $('.tab-menu-list-pdp li span').click(function () {
        var position2 = $(this).position();
        scroll4 = $('.pdp-tab-list-box').scrollLeft();
        $('.pdp-tab-list-box').animate({
            'scrollLeft': scroll4 + position2.left - 150
        }, 200);
    });

 $('.top-header-hide').click(function(){
       $(".top-header").css("display", "none");
    });
    $('.tab-menu-list-faq li span').on('click', function(){
        var target = $(this).attr('data-rel');
        $('.tab-menu-list-faq li span').removeClass('active');
          $(this).addClass('active');
          $("#"+target).fadeIn('slow').siblings(".tab-output-box-faq").hide();
          return false;
    });
    $('.faq-tab-category li span').click(function () {
        var position = $(this).position();
        scroll2 = $('.faq-tab-category').scrollLeft();
        $('.faq-tab-category').animate({
            'scrollLeft': scroll2 + position.left - 150
        }, 200);
    });
    $('.faq-title').click(function () {
        $(this).parent(".faq-box").toggleClass('active').siblings(".faq-box").removeClass("active");
    });

   if ($('.productCardthumb .swiper-slide').length <= 3) {
        $('.productCardthumb').addClass('centerthumbCard');
    } else {
        $('.productCardthumb').removeClass('centerthumbCard');
    }

    
    new Swiper('.bannerSlider', {
        loop: true,
        pagination: {
            el: '.banner-pagination',
               type: 'bullets',
            clickable:'true'
          },
      autoplay: {
    delay: 3000,
  },
        spaceBetween: 0
    });

    
    new Swiper(".shopByBrandSlider", {
      slidesPerView: 7,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          320: {
              loop: false,
              spaceBetween: 2,
              slidesPerView: 3,
          },
          479: {
              spaceBetween: 3,
              slidesPerView: 4,
          },
          768: {
              spaceBetween: 5,
              slidesPerView: 5,
          },
          992: {
              slidesPerView: 6,
              spaceBetween: 5,
          },
          1025: {
              slidesPerView: 7,
              slidesPerGroup: 2,
              spaceBetween: 5,
          },
      }
    });

  
      new Swiper(".productSlider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
       
        
        breakpoints: {
            320: {
                spaceBetween: 10,
                slidesPerView: 2.5,
              
               
            },
            393: {
                spaceBetween: 15,
                slidesPerView: 2.5,
              
               
            },
            480: {
                spaceBetween: 15,
                slidesPerView: 1.5,
              
                 
              
            },
            768: {
                spaceBetween: 15,
                slidesPerView: 1.5,
             
            },
            992: {
                slidesPerView: 2.2,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 2.6,
                spaceBetween: 55,
            },
        }
      });

      new Swiper(".brandsrtbs", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            320: {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            479: {
                loop: false,
                spaceBetween: 20,
                slidesPerView: 3,
            },
            768: {
                loop: false,
                spaceBetween: 30,
                slidesPerView: 3,
            },
            992: {
                loop: false,
                slidesPerView: 3,
                spaceBetween: 40,
            },
            1025: {
              
                slidesPerView: 3,
                spaceBetween: 60,
            },
        }
      });

      new Swiper(".simple-steps", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            320: {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            479: {
                loop: false,
                spaceBetween: 20,
                slidesPerView: 3,
            },
            768: {
                loop: false,
                spaceBetween: 30,
                slidesPerView: 3,
            },
            992: {
                loop: false,
                slidesPerView: 3,
                spaceBetween: 40,
            },
            1025: {
              
                slidesPerView: 3,
                spaceBetween: 60,
            },
        }
      });

      new Swiper(".blog-slider", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            320: {
                loop: true,
                spaceBetween: 10,
                slidesPerView: 2.2,
            },
            393: {
                spaceBetween: 15,
                slidesPerView: 2.4,
            },
            480: {
                spaceBetween: 15,
                slidesPerView: 2.2,
            },
            768: {
                spaceBetween: 15,
                slidesPerView: 2.5,
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 30,
            },
        }
      });

    

});

new Swiper(".productCategorySlider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        320: {
            spaceBetween: 10,
            slidesPerView: 2.5,
        },
        393: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        480: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.3,
        },
        992: {
            slidesPerView: 3,
            spaceBetween:15,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    }
  });


// Akash pdp js
new Swiper(".ingre-slider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        320: {
            spaceBetween: 20,
            slidesPerView: 1,
        },
        479: {
            spaceBetween: 20,
            slidesPerView: 1,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 55,
        },
    }
  });



var swiper = new Swiper(".productCardthumb", {
spaceBetween: 10,
slidesPerView: 4,  
centeredSlidesBounds:true,
freeMode: true,
watchSlidesProgress: true,
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
});
var swiper2 = new Swiper(".productCard", {
spaceBetween: 10,

pagination: {
    el: '.pdp-pagination',
       type: 'bullets',
    clickable:'true'
  },

navigation: {
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
},
thumbs: {
  swiper: swiper,
},

breakpoints: {
    320: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 1,
    },
}



});

var swiper = new Swiper(".alsolikeSlider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        320: {
            spaceBetween: 20,
            slidesPerView: 2,
        },
        479: {
            spaceBetween: 20,
            slidesPerView: 2,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1360: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    }
  });
var swiper = new Swiper(".fbt_slider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        320: {
            spaceBetween: 20,
            slidesPerView: 2,
          
        },
        479: {
            spaceBetween: 20,
            slidesPerView: 2,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1360: {
            slidesPerView: 4,
            spaceBetween: 30,
          navigation: {
    disabledClass: 'disabled_swiper_button'
  },
        
        },
    }
  });

//Base image slider

$(document).ready(function(){
  $(".product-share").click(function(){
    $(".share-social-media").toggleClass("addSlide");
  });
//clickMe();
  $('.swiper-wrapper .swiper-slide.base-image').each(function(index, elm) {
    var self = $(this);
      var thumbnailPos = self.data('rel');
      var selectedPos = $('.pdp-variant-selected span').data('pos');
      
});
  //Thumbnail image slider
  //$('.swiper-wrapper .swiper-slide.swiper-slide-visible').removeClass('swiper-slide-thumb-active');
  // $('.swiper-wrapper .swiper-slide.swiper-slide-visible').each(function(){
  //     var thumbnailPos = $(this).data('rel');
  //     var selectedPos = $('.pdp-variant-selected span').data('pos');
  //     $(this).removeClass('swiper-slide-thumb-active');
  //     if (thumbnailPos == selectedPos) {
  //       console.log("Thumbnail: " + thumbnailPos +"-------"+ selectedPos);
  //       $(this).addClass('swiper-slide-thumb-active');
  //     }
  // });


  
  
  
});
$(document).ready(function() {
  $('#submit-btn').click(function(){
    var pass = $('#CustomerPassword').val();
    var email = $('#CustomerEmail').val();
    if(email== ''){
      $('#itemBlank').html("<div class='errors'><ul><li>Please enter email</li></ul></div>");
      return false;
    }
    if(IsEmail(email) === false) {
      $('#itemBlank').html("<div class='errors'><ul><li>Incorrect email</li></ul></div>");
      return false;
    }
    if(pass== ''){
      $('#itemBlank').html("<div class='errors'><ul><li>Please enter password</li></ul></div>");
      return false;
    }
  });
});
   function IsEmail(email) {
            const regex =/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(email)) {
                return false;
            }
            else {
                return true;
            }
        }
 $(document).ready(function(){
      const searchParams = new URLSearchParams(window.location.search);
      let found = false;
      if(searchParams.has('variant')) {
          found = true;
      }
      if (!found) {
          $(".pack-block a:first-child").addClass("active");
      } 

// For variant images.
const baseSource = $('.pdp-variant-selected.base .selected-variant');
const thumbSource = $('.pdp-variant-selected.thumb .selected-variant');
// validate length of variant images and it will show all cases. 
if (baseSource.children().length > 0 && thumbSource.children().length > 0) {
    $('.swiper.base .swiper-wrapper').html(baseSource.html());
    $('.thumbSlider .swiper-wrapper').html(thumbSource.html());
    $('.swiper.base .swiper-wrapper .swiper-slide').css("visibility", "visible");
    $('.thumbSlider .swiper-wrapper .swiper-slide').css("visibility", "visible");
} else {
    $('.swiper.base .swiper-wrapper .swiper-slide').css("visibility", "visible");
    $('.thumbSlider .swiper-wrapper .swiper-slide').css("visibility", "visible");
}
      
  
    $(".pack-block a").each(function(k, v) {
      if(found) {
          $(this).removeClass("active");
          let id = $(this).attr('data-rel-id');
          if (id == searchParams.get('variant')) {
            $(this).addClass("active");
          }
      }
    });

   // setTimeout(function(){
   //  let emailElm = $(".cf-field-container .cf-field input[name='email']");
   //       if(emailElm.val()) {
   //            emailElm.hide();
   //            emailElm.after('<span>' + emailElm.val() + '</span>'); 
   //       }
   //  },1000);
 });
// $(document).ready(function(){
//   if ($(".addressAction").find('.badge').length > 0){
//     $(".delete-address").css("pointer-events", "none");
//   }
// });
  // $(document).ready(function() {
  //   $( ".jdgm-form__fieldset-actions" ).on( "submit", function( event ) {
  //     var titleName = $("input[name='review_title']").val();
  //     alert(titleName);
      
  //     if (titleName == '') {
  //       $('#itemBlank').html("<div id='jdgm_review_body_higcxpvy-error' class='jdgm-input-error'>This field is required.</div>");
  //       return false;
  //     }
  //   });
  // });
new Swiper(".productbrandCategorySlider", {
  
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
            320: {
                spaceBetween: 10,
                slidesPerView: 2.2,
            },
            393: {
                spaceBetween: 15,
                slidesPerView: 1.4,
            },
        480: {
            spaceBetween: 15,
            slidesPerView: 1.1,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 4,
            spaceBetween:15,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    }
  });


new Swiper(".brandVdSLider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
          
        1025: {
            slidesPerView: 1,
            // spaceBetween: 40,
        },
    }
  });

// For popup form
 // setTimeout(function () {
 //        $('#signup-modal').show();
 //    }, 60000);

    $(document).ready(function () {
        $("#signup-modal .close-button-modal").click(function () {
            $("#signup-modal").hide();
          
        })
    });

    $(document).ready(function () {
        $("#feedback-modal .close-button-modal").click(function () {
            $("#feedback-modal").hide();
          $("body").css("overflow","auto");
          
        })
    });

// Feedback popup open
$(document).ready(function() {
  $("a#feedback_form ").click(function(){
     $("#feedback-modal").show();
  })
 $(".cancel-btn").click(function(){
     $("#feedback-modal").hide();
  }) 
});
$(document).ready(function() {
    // Add a click event listener to all feedback links
    $('.feedback-link').on('click', function(event) {
      event.preventDefault();

      // Get the data attributes
      var email = $(this).data('email');
      var firstname = $(this).data('firstname');
      var orderid = $(this).data('orderid');

      // Populate the form fields
      $('#name').val(firstname);
      $('#email').val(email);
      $('#order_number').val(orderid);

      // Open the feedback modal
      openFeedbackModal();
    });

    // Function to open the feedback modal
    function openFeedbackModal() {
      var feedbackModal = $('#feedback-modal');
      if (feedbackModal.length) {
        feedbackModal.show();
      }
    }

  
  });
$(document).ready(function() {
      /*
      $("#zip-check").submit(function(e) {
        e.preventDefault();
        var inputValue = $(this).serialize();        
        if (validatePIN(inputValue.split('=')[1])) {
          $('#message').html(""); 
          $.ajax({
            url: 'https://rclub-store.myshopify.com/',
            type: "GET",
            //data: 'section_id=pincodes&' +inputValue +'&timestamp=' + Math.floor(Date.now() / 1000),
            data: 'section_id=pincodes&' + inputValue + '&timestamp=' + Math.floor(Date.now() / 1000) + '&rand=' + Math.random(),
            cache:false,
            success: function(response) {
              response = parseInt($(response).find("#shopify-section-pincodes").text());
              if(!response) {
                console.log("ONLY SHOWING ZERO");
              } else {
                console.log("HAN THEEK HAI");
              }
               $('#message').html("<div class='errors'>We deliver to your zipcode</div>");
            },
            error: function(xhr, status, error) {
              console.error("Error:", status, error);
              $('#message').html("<div class='errors'>Unfortunately we do not ship to your zipcode</div>");
            }
          });
        } else {
          $('#message').html("<div class='errors'>Invalid pincode. Please enter 6 digits</div>");
        }
      });
      

      $("#zipcodechecker").keypress(function(event) {
        var charCode = event.which;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          event.preventDefault();
        }
      });
      */
      function validatePIN(inputValue) {
        var regex = /^[0-9]{6}$/;
        return regex.test(inputValue);
      }
    });              
	
$("#zipcodechecker").on("keyup", function(event) {
    var charCode = event.which;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
    }
});	
//Close header on click
document.addEventListener('DOMContentLoaded', function () {
    var setCookieButton = document.getElementById('setCookieButton');
    setCookieButton.addEventListener('click', function () {
      var topHeader = document.querySelector('.top-header');
      topHeader.style.display = 'none';
    });
  });
//End code

// Set headercookie for 1 day
  // function setCookie(name, value, days) {
  //   var expires = "";
  //   if (days) {
  //     var date = new Date();
  //     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  //     expires = "; expires=" + date.toUTCString();
  //   }
  //   document.cookie = name + "=" + value + expires + "; path=/";
  // }
  // document.getElementById("setCookieButton").addEventListener("click", function() {
  //   document.querySelector(".top-header").style.display = "none"; 
  //   setCookie("topHeaderHidden", "true", 1);
  // });

  // if (document.cookie.indexOf("topHeaderHidden=true") !== -1) {
  //   document.querySelector(".top-header").style.display = "none";
  // }  

// Set cookie and policy
 // $(document).ready(function () {
 //        if (localStorage.getItem('cookieAccepted') !== 'true') {
 //            $('#cookieNotice').show();
 //        }

 //        $('#acceptCookiesBtn').on('click', function () {
 //            acceptCookies();
 //        });

 //        $('#declineCookiesBtn').on('click', function () {
 //            declineCookies();
 //        });
 //    });
 //    function acceptCookies() {
 //        localStorage.setItem('cookieAccepted', 'true');
 //        $('#cookieNotice').hide();
       
 //    }
 //    function declineCookies() {
 //        alert('Cookies are not accepted. Some features may not work properly.');
 //        $('#cookieNotice').hide();
 //    }

function openPopup() {
    document.getElementById('signup-modal').style.display = 'block'; 
}

function closePopup() {
    document.getElementById('signup-modal').style.display = 'none'; 
    setCookie('modalClosed', 'true', 1); 
    console.log('Popup closed. modalClosed set to true.');
}

// Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); 
        expires = "; expires=" + date.toUTCString();
    }
    // Set SameSite attribute to None and Secure
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=None; Secure"; 
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length); 
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length); 
    }
    return null; 
}

function initializePopup() {
    var modalClosed = getCookie('modalClosed'); 

    if (!modalClosed) {
        setTimeout(openPopup, 6000); // Show popup after 6 seconds if not closed
    }
}

document.addEventListener('DOMContentLoaded', initializePopup);




//menu custom js
  if (window.matchMedia("(max-width: 767px)").matches) {
         $(document).ready(function(){
    $(".megamenu-mobile a").click(function(){
       $(this).addClass("active");
        $(".megamenu").toggle(300);
    })

    $(".brandCat .brandHead").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".brandCat ul").slideUp();
        } else {
          $(".brandCat .brandHead").removeClass("active");
          $(this).addClass("active");
          $(".brandCat ul").slideUp();
          $(this).siblings(".brandCat ul").slideDown();
        }
    });    
  })
  }

//For mobile menu - trigger not work 
if (window.innerWidth <= 767) {
    var mobileAnchor = document.getElementById('mobileAnchor');
    mobileAnchor.addEventListener('click', function(event) {
        event.preventDefault(); 
    });
}


$(document).ready(function(){
		<!--Smooth Page Scroll to Top-->
			$(window).scroll(function(){
				if ($(this).scrollTop() > 100) {
					$('.scrollup').fadeIn();
				} else {
					$('.scrollup').fadeOut();
				}
			}); 
	 
			$('.scrollup').click(function(){
				$("html, body").animate({ scrollTop: 0 }, 600);
				return false;
			});

$(".left-box-header .tooglebar").click(function(){
  $("body").addClass("overflow-scroll-y");
});
$(".close-menu").click(function(){
  $("body").removeClass(".overflow-scroll-y");
})
    	
});
//   loyalty program

new Swiper(".earnMoreCard", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        310: {
            spaceBetween: 20,
            slidesPerView: 1.2,
        },

        480: {
            spaceBetween: 50,
            slidesPerView: 1.2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
          
        1025: {
            slidesPerView: 3.3,
            spaceBetween: 30,
        },
        
    }
  });

  new Swiper(".productredemSlider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  
    breakpoints: {
      
      
        320: {
            spaceBetween: 15,
            slidesPerView: 1.2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    }
  });

  new Swiper(".experienceSlider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
 
    breakpoints: {
        320: {
            spaceBetween: 15,
            slidesPerView: 1.2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 55,
        },
    }
  });

  new Swiper(".voucherSlider", {
  
 
    breakpoints: {
        310: {
            spaceBetween: 20,
            slidesPerView: 3.5,
        },
        480: {
            spaceBetween: 15,
            slidesPerView: 3.2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 5,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 6,
            spaceBetween: 40,
        },
    }
  });
  new Swiper(".eventSlider", {
   
    breakpoints: {
        310: {
            spaceBetween: 20,
            slidesPerView: 1.2,
        },

        480: {
            spaceBetween: 15,
            slidesPerView: 2.2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 2.5,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 3.7,
            spaceBetween: 40,
        },
    }
  });
  
// about us page


  new Swiper(".abt-slider", {

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
   
    breakpoints: {
        310: {
            spaceBetween: 20,
            slidesPerView: 1,
        },

        480: {
            spaceBetween: 15,
            slidesPerView: 2,
        },
        768: {
            spaceBetween: 15,
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 17,
        },
    }
  });

const mediaQuerybyall = window.matchMedia('(max-width: 767px)')

if (mediaQuerybyall.matches) {
    new Swiper(".valueSlider", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
       
        breakpoints: {
           
    
            480: {
                spaceBetween: 0,
                slidesPerView: 1,
            },
           
        }
      });

}

$(document).ready(function() {
    $('.swiper-wrapper').removeClass('hide2');
   $('.swiper-wrapper').removeClass('hide');
  });
$(document).ready(function(){
    $('.delite').click(function(event){
        if ($(this).hasClass('disabled')) {
            event.preventDefault();
            return;
        }
        $(this).addClass('disabled');
    });
});
$(document).ready(function() {
    // Add click event handler to the button
    $('#pay-button-container button').click(function() {
        // Hide the div with class _1ip0g651
        $('._1ip0g651').hide();
    });
});
$(document).ready(function(){
    setTimeout(function() {
        $("#shopify-pc__banner__btn-decline").hide();
        $(".shopify-pc__banner__btns button:nth-child(3)").hide();
    }, 500); 
});



//manthan Js
    $(document).ready(function () {

       $(".zero-hover").on({
            mouseenter: function () {
                 $(".zero-hover").addClass("guest-hover");
            
            },
            mouseleave: function () {
                 $(".zero-hover").removeClass("guest-hover");
            }, 
        });


     $(".first-hover").on({
            mouseenter: function () {
                 $(".first-hover").addClass("welcome-hover");
            
            },
            mouseleave: function () {
                 $(".first-hover").removeClass("welcome-hover");
            }, 
        });

           $(".second-hover").on({
            mouseenter: function () {
                 $(".second-hover").addClass("blue-hover");
            
            },
            mouseleave: function () {
                 $(".second-hover").removeClass("blue-hover");
            }, 
        });

       $(".third-hover").on({
            mouseenter: function () {
                 $(".third-hover").addClass("silver-hover");
            
            },
            mouseleave: function () {
                 $(".third-hover").removeClass("silver-hover");
            }, 
        });

             $(".forth-hover").on({
            mouseenter: function () {
                 $(".forth-hover").addClass("gold-hover");
            
            },
            mouseleave: function () {
                 $(".forth-hover").removeClass("gold-hover");
            }, 
        });
    $(".fifth-hover").on({
            mouseenter: function () {
                 $(".fifth-hover").addClass("platinum-hover");
            
            },
            mouseleave: function () {
                 $(".fifth-hover").removeClass("platinum-hover");
            }, 
        });
    
      });

$(document).ready(function () {
    $(".toggle-btn").click(function () {
        const additionalInfo = $(this).siblings(".additional-info");
        if (additionalInfo.is(":visible")) {
            additionalInfo.slideUp(300);  
            $(this).text("Read More"); 
        } else {
            additionalInfo.slideDown(300); 
            $(this).text("Read Less"); 
        }
    });
});

$(document).ready(function() {
  const currentHandle = window.location.pathname.split('/').pop();
  $(".pack-block a").each(function() {
    const linkHandle = $(this).attr('data-handle'); 
    if (linkHandle === currentHandle) {
      $(this).addClass("active"); 
    } else {
      $(this).removeClass("active"); 
    }
  });
});
